/* Regalo automático – Octubre 2026
   - $1,500+ en productos participantes → Certificado Booster (gratis)
   - $3,000+ en productos participantes → Certificado Entrenamiento manual + Booster (gratis)
   Solo un regalo a la vez, porque los descuentos no se combinan.

   Actualiza el drawer del carrito y el ícono del header usando la misma
   Section Rendering API que usa el tema (product-form.js / cart-drawer.js),
   para no tener que recargar la página. Si el usuario está en /cart (donde
   la tabla de productos no es parte del drawer), recarga como respaldo. */
(() => {
  // Productos que cuentan para la promoción (los 18 de ambos descuentos)
  const ELIGIBLE_PRODUCT_IDS = [
    4486196920385, 4487623049281, 4487660503105, 4488068595777,
    4488080851009, 4488098709569, 4488382251073, 4558337376321,
    4558338785345, 6093774454958, 6113825226926, 8138564534492,
    8871921549532, 8873771401436, 8962903900380, 9089063059676,
    9089066270940, 9259103158492
  ];

  // Niveles de regalo, de mayor a menor (montos en centavos MXN)
  const GIFT_TIERS = [
    { min: 300000, variantId: 67669317288156 }, // Entrenamiento manual + Booster ($3,000+)
    { min: 150000, variantId: 47018962551004 }  // Booster ($1,500+)
  ];

  // Vigencia igual a la de los descuentos
  const STARTS = new Date('2026-10-15T06:00:00Z');
  const ENDS   = new Date('2026-11-01T05:59:00Z');

  // Secciones que se piden a la Section Rendering API para actualizar
  // el carrito sin recargar (mismas que usa product-form.js)
  const CART_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  const GIFT_IDS = GIFT_TIERS.map(t => t.variantId);
  const nativeFetch = window.fetch.bind(window);
  let busy = false;

  const post = (url, body) => nativeFetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  });

  function extractSectionHTML(html, selector) {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  // Igual que CartDrawer.renderContents(), pero sin abrir el drawer: solo
  // refresca su contenido y el ícono del carrito en el header.
  function applyCartSections(sections) {
    if (!sections) return;

    if (sections['cart-drawer']) {
      const target = document.getElementById('CartDrawer');
      const html = extractSectionHTML(sections['cart-drawer'], '#CartDrawer');
      if (target && html != null) {
        target.innerHTML = html;
        // El overlay se recrea con el innerHTML y pierde su listener de cierre.
        const overlay = target.querySelector('#CartDrawer-Overlay');
        const drawerEl = document.querySelector('cart-drawer');
        if (overlay && drawerEl && typeof drawerEl.close === 'function') {
          overlay.addEventListener('click', drawerEl.close.bind(drawerEl));
        }
      }
    }

    if (sections['cart-icon-bubble']) {
      const target = document.getElementById('cart-icon-bubble');
      const html = extractSectionHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (target && html != null) target.innerHTML = html;
    }
  }

  async function syncGift() {
    if (busy) return;
    busy = true;
    try {
      const cart = await nativeFetch('/cart.js').then(r => r.json());
      const now = new Date();
      const active = now >= STARTS && now < ENDS;

      // Suma solo los productos participantes
      const eligibleTotal = cart.items
        .filter(i => ELIGIBLE_PRODUCT_IDS.includes(i.product_id))
        .reduce((sum, i) => sum + i.final_line_price, 0);

      // Elige el regalo que corresponde al monto
      const tier = active ? GIFT_TIERS.find(t => eligibleTotal >= t.min) : null;
      const targetId = tier ? tier.variantId : null;

      // Solo maneja los regalos que agregó este script
      const giftLines = cart.items.filter(i =>
        GIFT_IDS.includes(i.variant_id) && i.properties && i.properties._regalo_auto
      );

      let changed = false;
      let lastResponse = null;
      const sectionsParams = { sections: CART_SECTIONS, sections_url: window.location.pathname };

      // Quita el regalo que ya no corresponde o ajusta su cantidad a 1
      for (const line of giftLines) {
        const keep = line.variant_id === targetId;
        if (!keep || line.quantity !== 1) {
          const res = await post('/cart/change.js', {
            id: line.key,
            quantity: keep ? 1 : 0,
            ...sectionsParams
          });
          if (res.ok) lastResponse = await res.json();
          changed = true;
        }
      }

      // Agrega el regalo correcto si todavía no está
      if (targetId && !giftLines.some(l => l.variant_id === targetId)) {
        const res = await post('/cart/add.js', {
          items: [{ id: targetId, quantity: 1, properties: { _regalo_auto: 'Octubre 2026' } }],
          ...sectionsParams
        });
        if (res.ok) {
          lastResponse = await res.json();
          changed = true;
        }
      }

      if (changed) {
        const onCartPage = window.routes && window.location.pathname === window.routes.cart_url;
        if (onCartPage) {
          // La tabla de /cart no forma parte del drawer: ahí sí recargamos.
          location.reload();
        } else if (lastResponse && lastResponse.sections) {
          applyCartSections(lastResponse.sections);
        } else {
          location.reload(); // respaldo si por algo no llegaron las secciones
        }
      }
    } catch (e) {
      console.error('Regalo automático:', e);
    } finally {
      busy = false;
    }
  }

  // Revisa el carrito cada vez que el tema lo modifica
  window.fetch = async (...args) => {
    const res = await nativeFetch(...args);
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(url)) setTimeout(syncGift, 300);
    return res;
  };

  document.addEventListener('DOMContentLoaded', syncGift);
})();
